"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroEventCreateDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const boolean_transform_1 = require("../../constants/boolean.transform");
const shared_1 = require("../shared");
// TODO: the enum undefined issue is occurring here again, investigate this another time
class HeroEventCreateDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (options)
            Object.assign(this, options);
    }
    getFields() {
        return [
            'name',
            'eventRefId',
            'eventCategoryId',
            'allowMultipleEntries',
            'requireScanOut',
            'openToAll',
            'active',
            'duration',
            'startDate',
            'endDate',
            'startTime',
            'recurrenceScheduledDays',
            'skipWeekends',
            'monthlyRecurrence',
            'recurrence'
        ];
    }
    name;
    allowMultipleEntries;
    requireScanOut;
    openToAll;
    eventCategoryId;
    startDate;
    endDate;
    startTime;
    duration;
    skipWeekends;
    // @IsEnum(HeroEventRecurrenceEnum)
    recurrence;
    monthlyRecurrence;
    recurrenceScheduledDays;
}
exports.HeroEventCreateDto = HeroEventCreateDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], HeroEventCreateDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], HeroEventCreateDto.prototype, "allowMultipleEntries", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], HeroEventCreateDto.prototype, "requireScanOut", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], HeroEventCreateDto.prototype, "openToAll", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], HeroEventCreateDto.prototype, "eventCategoryId", void 0);
__decorate([
    (0, class_validator_1.IsDate)({ message: 'Please provide a valid start date.' }),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    __metadata("design:type", Date)
], HeroEventCreateDto.prototype, "startDate", void 0);
__decorate([
    (0, class_validator_1.IsDate)({ message: 'Please provide a valid start date.' }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : undefined)),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], HeroEventCreateDto.prototype, "endDate", void 0);
__decorate([
    (0, shared_1.ExportTime)('heroEventStartTime', 'recurrence', 'startDate'),
    __metadata("design:type", String)
], HeroEventCreateDto.prototype, "startTime", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], HeroEventCreateDto.prototype, "duration", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], HeroEventCreateDto.prototype, "skipWeekends", void 0);
__decorate([
    (0, class_validator_1.ArrayUnique)()
    // @IsEnum(DaysOfWeekEnum, { each: true })
    ,
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], HeroEventCreateDto.prototype, "recurrenceScheduledDays", void 0);
